import {
  CENARIOS_ADD,
  CENARIOS_LIST,
  CENARIOS_REMOVE,
  CENARIOS_MODIFY,
} from "../const/servicesURI";
import requestService from "./requestService";
import { httpRequests } from "investira.sdk";
import utils from "../utils";

const cancel = {
  list: null,
};

export const list = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.list.token,
  };

  return requestService(xProps, CENARIOS_LIST, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Cenários List");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const add = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "POST",
  };

  return requestService(xProps, CENARIOS_ADD, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Cenários Add");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const remove = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "DELETE",
  };

  return requestService(xProps, CENARIOS_REMOVE, 3)
    .then((rRes) => {
      pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Cenários Remove");
      pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const modify = (pProps, pResolve, pReject, pFinally) => {
  const xProps = {
    data: { ...pProps },
    method: "PATCH",
  };

  return requestService(xProps, CENARIOS_MODIFY, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Cenários Modify");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};
const cenarios = { list, add, modify, remove, cancel };

export default cenarios;
